import React from 'react';
import Popup from '../../../../../../components/common/popUp/PopUp';
import ChangeLang from './ChangeLang/ChangeLang';
import styles from './nameChoice.css';

/**
 *
 * @type {React.NamedExoticComponent<{handleTemplateNameChange?: *, content?: *, template?: *, handlePersonTypesCountChange?: *, handleToggleTemplateWizard?: *, display?: *, handleTemplateCreation?: *, handleTemplateLanguageChange?: *}>}
 */
const NameChoice = React.memo ( ( { handleToggleTemplateWizard, template, handleTemplateNameChange, handlePersonTypesCountChange,
                                      handleTemplateLanguageChange, handleTemplateCreation, display, content } ) => (
    <Popup
        handleClose={ handleToggleTemplateWizard }
        windowStyle={ {
            minHeight: '30rem',
            maxHeight: '45%',
            width: '90rem',
            borderRadius: '0.5rem',
            backgroundColor: '#fff',
            boxShadow: '0 0.5rem 6.4rem 0 rgba(0, 0, 0, 0.24)'
        } }
    >
        <div className={ styles.wrapper } onClick={ () => {
            display=!display;
        } }>
            <input
                type='text'
                placeholder={ `${ content.quiz.editor.name }` }
                className={ styles.input }
                value={ template.name }
                onChange={ handleTemplateNameChange }
            />

            {
                template.type === 'person' && (
                    <div>
                        <input
                            type='number'
                            placeholder={ 'Number of types' }
                            min={ 2 }
                            max={ 100 }
                            className={ styles.input }
                            value={ template.personTypeCount }
                            onChange={ handlePersonTypesCountChange }
                        />
                        <p style={ { color: 'grey', paddingTop: '1rem' } }>
                            Set how many personality types you need. It is possible to change it later
                        </p>
                    </div>
                )
            }
            <ChangeLang
                disp={ display }
                handleTemplateLanguageChange={ handleTemplateLanguageChange }
            />
            <div className={ styles.buttonBox }>
                <button className={ styles.button } onClick={ handleTemplateCreation }>
                    { content.dashboard.create }
                </button>
            </div>
        </div>
    </Popup>
) );

export default NameChoice;
